"use client"

import { Badge } from "@/components/ui/badge"
import { FileSearch, CalendarX, Receipt, PackageX, ArrowRight } from "lucide-react"

const logros = [
  {
    icon: FileSearch,
    titulo: "Expediente listo en consulta",
    antes: "Buscas carpetas, Excel o notas sueltas antes de atender.",
    despues: "Abres el perfil del paciente y tienes antecedentes, odontograma y historial al instante.",
  },
  {
    icon: CalendarX,
    titulo: "Agenda sin sorpresas",
    antes: "Dobles citas, horarios cruzados y cambios que no llegan a todo el equipo.",
    despues: "Todos ven la misma agenda actualizada, filtrada por dentista y estado.",
  },
  {
    icon: Receipt,
    titulo: "Cobros bajo control",
    antes: "Pagos parciales en un cuaderno y pendientes que se olvidan al cierre del mes.",
    despues: "Cada pago queda registrado con recibo, saldo pendiente y reporte financiero.",
  },
  {
    icon: PackageX,
    titulo: "Inventario sin quiebres",
    antes: "Te enteras que faltan insumos cuando ya estás en medio del procedimiento.",
    despues: "Alertas de stock bajo y movimientos registrados antes de que falte material.",
  },
]

export function Outcomes() {
  return (
    <section className="py-24 bg-white relative overflow-hidden">
      <div className="container mx-auto px-6 max-w-6xl">
        {/* Header Section */}
        <div className="text-center mb-20">
          <Badge className="mb-4 bg-teal-50 text-teal-700 hover:bg-teal-50 border-none px-4 py-1 rounded-full font-medium">
            Lo que puedes lograr
          </Badge>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 tracking-tight">
            Así cambia tu día a día
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto leading-relaxed">
            Elimina el caos administrativo. Transformamos flujos de trabajo 
            desordenados en procesos digitales fluidos y eficientes.
          </p>
        </div>

        {/* Grid Section */}
        <div className="grid md:grid-cols-2 gap-6">
          {logros.map(({ icon: Icon, titulo, antes, despues }, idx) => (
            <div
              key={idx}
              className="group relative p-8 rounded-3xl border border-slate-100 bg-white shadow-sm hover:shadow-xl hover:shadow-teal-500/5 transition-all duration-300 hover:-translate-y-1"
            >
              {/* Icon */}
              <div className="w-12 h-12 rounded-2xl bg-teal-50 flex items-center justify-center text-teal-600 mb-6 group-hover:scale-110 transition-transform duration-300">
                <Icon className="h-6 w-6" />
              </div>

              <h3 className="text-xl font-semibold text-slate-900 mb-6">{titulo}</h3>

              <div className="space-y-6">
                <div className="relative pl-4 border-l-2 border-slate-200">
                  <span className="block text-[10px] font-bold uppercase tracking-widest text-slate-400 mb-1">Antes</span>
                  <p className="text-sm text-slate-500">{antes}</p>
                </div>
                
                <div className="pl-4">
                  <div className="flex items-center gap-2 text-teal-600 font-bold text-sm mb-1">
                    <ArrowRight className="h-4 w-4" />
                    <span>Con AsistDental</span>
                  </div>
                  <p className="text-slate-700 font-medium leading-relaxed">{despues}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Footer Note */}
        <p className="text-center text-slate-400 text-sm mt-16 italic">
          Resultados basados en la optimización operativa de clínicas dentales modernas.
        </p>
      </div>
    </section>
  )
}